export class TreeUtils {

  // Given the rootNode of a tree, returns the list of leafIds as well as a maps of idToNode and codeToNode
  static parseTree = (rootNode) => {
    const leafIds = [];
    const idToNode = {};
    const codeToNode = {};

    const traverseNodes = (node) => {
      idToNode[node.id] = node;
      codeToNode[node.code] = node;
      if (node.children?.length > 0) {
        node.children.forEach(child => {
          traverseNodes(child);
        })
      } else {
        leafIds.push(node.id);
      }
    }

    traverseNodes(rootNode);
    return { leafIds, idToNode, codeToNode };
  }

}